/* PSI Free Gift — v1 (22 Oct 2026). Replaces Kite: Discount & Free Gift.
 *
 * Keeps the free Balloon Garland Arch DIY Kit in the cart when the cart
 * (excluding the gift) reaches the threshold, and takes it out when it drops
 * below. The price itself is set by Shopify's automatic discount, never here.
 *
 * Safety rules:
 *  - Only the line this script added (property _psi_free_gift) is ever changed
 *    or removed. A kit the customer chose to buy is never touched.
 *  - After adding, the cart is re-read; if the gift is not at Rs. 0 it is
 *    removed again at once and not retried this session (no charged "gift").
 *  - If the customer removes the gift, it is not re-added this session; the
 *    bar then offers an "Add my gift" button.
 *  - Any error leaves the cart as it was (fails closed, silently).
 */
(function () {
  'use strict';
  var CFG = window.PSI_FREE_GIFT;
  if (!CFG || !CFG.variantId || !CFG.threshold || window.__psiFreeGiftLoaded) return;
  window.__psiFreeGiftLoaded = true;

  var PROP = '_psi_free_gift';
  var K_DECLINED = 'psi_fg_declined', K_BLOCKED = 'psi_fg_blocked', K_HAD = 'psi_fg_had';
  var nativeFetch = window.fetch.bind(window);
  var timer = null, running = false, again = false, ownWrite = false;

  function ss(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      if (val === null) window.sessionStorage.removeItem(key); else window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function json(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return nativeFetch(root() + url, opts).then(function (r) {
      if (!r.ok) throw new Error('psi-fg ' + url + ' ' + r.status);
      return r.json();
    });
  }

  function giftLines(cart) {
    return cart.items.filter(function (i) { return i.variant_id === CFG.variantId; });
  }
  function ourLine(cart) {
    return giftLines(cart).filter(function (i) { return i.properties && i.properties[PROP]; })[0] || null;
  }
  function qualifying(cart) {
    return cart.items.reduce(function (sum, i) {
      return i.variant_id === CFG.variantId ? sum : sum + (i.original_line_price || 0);
    }, 0);
  }

  /* Re-render the cart drawer, cart page and cart count with Shopify's
     Section Rendering API — same selectors the theme itself uses. */
  function refreshSections() {
    var targets = [
      { el: 'mini-cart', sec: 'mini-cart', sel: '.shopify-section', inner: null },
      { el: 'cart-icon-bubble', sec: 'cart-icon-bubble', sel: '.shopify-section', inner: null },
      { el: 'mobile-cart-icon-bubble', sec: 'mobile-cart-icon-bubble', sel: '.shopify-section', inner: null }
    ];
    var mci = document.getElementById('main-cart-items');
    if (mci && mci.dataset.id) targets.push({ el: 'main-cart-items', sec: mci.dataset.id, sel: '.js-contents', inner: '.js-contents' });
    var mcf = document.getElementById('main-cart-footer');
    if (mcf && mcf.dataset.id) targets.push({ el: 'main-cart-footer', sec: mcf.dataset.id, sel: '.js-contents', inner: '.js-contents' });
    targets = targets.filter(function (t) { return document.getElementById(t.el); });
    if (!targets.length) return Promise.resolve();
    var ids = targets.map(function (t) { return t.sec; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    return nativeFetch(root() + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (html) {
        targets.forEach(function (t) {
          if (!html[t.sec]) return;
          var doc = new DOMParser().parseFromString(html[t.sec], 'text/html');
          var src = doc.querySelector(t.sel);
          var host = document.getElementById(t.el);
          var dest = t.inner ? host.querySelector(t.inner) : host;
          if (src && dest) dest.innerHTML = src.innerHTML;
        });
      });
  }

  function celebrate() {
    document.querySelectorAll('[data-psi-fg]').forEach(function (el) {
      el.classList.add('is-celebrating');
      setTimeout(function () { el.classList.remove('is-celebrating'); }, 700);
    });
  }

  function addGift() {
    ownWrite = true;
    var props = {}; props[PROP] = '1';
    return json('cart/add.js', { items: [{ id: CFG.variantId, quantity: 1, properties: props }] })
      .then(function () { return json('cart.js'); })
      .then(function (cart) {
        var line = ourLine(cart);
        if (line && line.final_line_price > 0) {
          // Discount did not apply: never leave a charged "free" gift behind.
          ss(K_BLOCKED, '1');
          return json('cart/change.js', { id: line.key, quantity: 0 }).then(function () { return false; });
        }
        ss(K_HAD, line ? '1' : null);
        return !!line;
      })
      .finally(function () { ownWrite = false; });
  }

  function removeGift(line) {
    ownWrite = true;
    return json('cart/change.js', { id: line.key, quantity: 0 })
      .then(function () { ss(K_HAD, null); })
      .finally(function () { ownWrite = false; });
  }

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    var changed = false, added = false;
    json('cart.js').then(function (cart) {
      var mine = ourLine(cart);
      var anyGift = giftLines(cart).length > 0;
      var eligible = qualifying(cart) >= CFG.threshold;

      if (!mine && ss(K_HAD) === '1') {          // our gift vanished, and we didn't remove it
        ss(K_HAD, null);
        if (eligible) ss(K_DECLINED, '1');       // customer removed it on purpose
      }
      if (!eligible) ss(K_DECLINED, null);       // fresh start once the cart drops below again

      if (mine && !eligible) { changed = true; return removeGift(mine); }
      if (mine && mine.quantity > 1) {
        changed = true; ownWrite = true;
        return json('cart/change.js', { id: mine.key, quantity: 1 }).finally(function () { ownWrite = false; });
      }
      if (mine) { ss(K_HAD, '1'); return; }
      if (eligible && !anyGift && ss(K_DECLINED) !== '1' && ss(K_BLOCKED) !== '1') {
        changed = true;
        return addGift().then(function (ok) { added = ok; });
      }
    }).then(function () {
      if (changed) return refreshSections().then(function () { if (added) celebrate(); });
    }).catch(function (e) {
      if (window.console) console.warn('[psi-free-gift]', e && e.message);
    }).finally(function () {
      running = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 400); }

  // Watch cart changes made by the theme or other apps.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!ownWrite && CART_WRITE.test(url)) p.then(schedule, function () {});
    } catch (e) {}
    return p;
  };
  document.addEventListener('cart:updated', schedule);

  // "Add my gift" button (customer removed it earlier).
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-psi-fg-add]');
    if (!btn) return;
    ev.preventDefault();
    btn.disabled = true;
    ss(K_DECLINED, null);
    if (ss(K_BLOCKED) === '1') { btn.disabled = false; return; }
    addGift().then(function (ok) { return refreshSections().then(function () { if (ok) celebrate(); }); })
      .catch(function () { btn.disabled = false; });
  });

  if (CFG.itemCount > 0) {
    if ('requestIdleCallback' in window) requestIdleCallback(reconcile, { timeout: 2500 }); else setTimeout(reconcile, 1200);
  }
})();
